import React, { useState } from 'react';
import './DonatePage.css';

const loadRazorpay = (src) => {
  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return resolve(true);
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
};

const DonatePage = ({ backendUrl }) => {
  const [amount, setAmount] = useState(20);
  const [currency, setCurrency] = useState('USD');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDonate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const loaded = await loadRazorpay('https://checkout.razorpay.com/v1/checkout.js');
    if (!loaded) {
      setStatus({ ok: false, msg: 'Failed to load payment SDK.' });
      setLoading(false);
      return;
    }

    try {
      const payload = { amount: parseFloat(amount) || 0, currency, name, email };
      const res = await fetch(`${backendUrl}/api/donate/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Order creation failed');

      const options = {
        key: data.keyId || process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.amount,
        currency: data.currency,
        name: 'OneAI Humanize Donation',
        description: `Donation: ${payload.currency} ${payload.amount}`,
        order_id: data.orderId,
        handler: async function (response) {
          // Verify donation with backend
          try {
            const verifyRes = await fetch(`${backendUrl}/api/donate/verify`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                name: payload.name,
                email: payload.email,
                amount: payload.amount,
                currency: payload.currency
              }),
            });
            const v = await verifyRes.json();
            if (verifyRes.ok) setStatus({ ok: true, msg: 'Thank you — donation received.' });
            else setStatus({ ok: false, msg: v.error || 'Verification failed.' });
          } catch (err) {
            console.error('verify error', err);
            setStatus({ ok: false, msg: 'Verification network error.' });
          }
        }
      };

  const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error('donation error', err);
      setStatus({ ok: false, msg: err.message || 'Donation failed' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="donate-root">
      <div className="donate-card">
        <h1 className="page-title">Support OneAI Humanize</h1>
        <p>We're a small team working to make AI feel more human. Your donation keeps servers running and people paid so we can keep building.</p>

        <form className="donate-form" onSubmit={handleDonate}>
          <label>
            Currency
            <select value={currency} onChange={e => setCurrency(e.target.value)}>
              <option value="USD">USD</option>
              <option value="INR">INR</option>
            </select>
          </label>

          <label>
            Amount ({currency})
            <input type="number" min="1" step="1" value={amount} onChange={e => setAmount(e.target.value)} />
          </label>
          <label>
            Your name (optional)
            <input type="text" value={name} onChange={e => setName(e.target.value)} />
          </label>
          <label>
            Email (optional)
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
          </label>

          <div className="donate-actions">
            {(() => {
              const sym = currency === 'INR' ? '₹' : '$';
              return (
                <button className="btn primary" type="submit" disabled={loading}>{loading ? 'Processing...' : `Donate ${sym}${amount}`}</button>
              );
            })()}
          </div>
        </form>

        {status && (
          <div className={`donate-status ${status.ok ? 'ok' : 'err'}`}>{status.msg}</div>
        )}
      </div>
    </div>
  );
};

export default DonatePage;
